// CIPT CUSTOM JS.
// import initializeMatchmaker from './modules/arch-front-memory'
// import initializeTypingSpell from './modules/arch-front-typing-spell'
// import { initializeMovingCTAs } from './modules/cipt_animations'
// import ajaxifyPaginationAndFilters from './modules/cipt_ajaxify';

// Add an optimized resize event.
// (function() {
// 	var throttle = function(type, name, obj) {
// 		obj = obj || window;
// 		var running = false;
// 		var func = function() {
// 			if (running) { return; }
// 			running = true;
// 				requestAnimationFrame(function() {
// 					obj.dispatchEvent(new CustomEvent(name))
// 					running = false;
// 			});
// 		};
// 		obj.addEventListener(type, func)
// 	};

// 	throttle("resize", "optimizedResize")
// })();
// Usage example: Recalculate on resize
// window.addEventListener("optimizedResize", function() {
// 	window.setTimeout( ()=>{
// 		console.log( 'optimized resize called!')
// 	}, 100)
// });




// Initial setup on Load.
// In order of need.
document.addEventListener('DOMContentLoaded', (event) => {
	console.log( 'IB Content Architecture: front scripts loaded' )

	// Add a spacer for our icon blocks when needed.
	// const iconParentsNeedingBottomSpacers = document.querySelectorAll(".wp-block-group:has(.wp-block-inz-o-icon.offset--offset-bottom):not(#main), .wp-block-media-text:has(.wp-block-inz-o-icon.offset--offset-bottom), .wp-block-columns:has(.wp-block-inz-o-icon.offset--offset-bottom)");
	// if (iconParentsNeedingBottomSpacers) {
	// 	const iconSpacer = document.createElement('div');
	// 	iconSpacer.setAttribute('class', 'wp-block-inz-o-icon--spacer wp-block-inz-o-icon--spacer--bottom')

	// 	iconParentsNeedingBottomSpacers.forEach(element => {
	// 		const newSpacer = iconSpacer.cloneNode(true)
	// 		element.after(newSpacer)
	// 	});
	// }
	// const iconParentsNeedingTopSpacers = document.querySelectorAll(".wp-block-group:has(.wp-block-inz-o-icon.offset--offset-top):not(#main), .wp-block-media-text:has(.wp-block-inz-o-icon.offset--offset-top), .wp-block-columns:has(.wp-block-inz-o-icon.offset--offset-top)");
	// if (iconParentsNeedingTopSpacers) {
	// 	const iconSpacer = document.createElement('div');
	// 	iconSpacer.setAttribute('class', 'wp-block-inz-o-icon--spacer wp-block-inz-o-icon--spacer--top')

	// 	iconParentsNeedingTopSpacers.forEach(element => {
	// 		const newSpacer = iconSpacer.cloneNode(true)
	// 		element.before(newSpacer)
	// 	});
	// }

})



